"use client";
import MuiRadio, {
  type RadioProps as MuiRadioProps,
} from "@mui/material/Radio";

export default function RadioControl(props: MuiRadioProps) {
  return <MuiRadio {...props} />;
}
